import { globalRepo as r, K } from "../globalRepo.js";
import { evaluateFormula } from "@yjsgames/formula-evaluator";

/** 월드 진행 설정 — global.tsv가 SSoT. */
export const WORLD = {
  /** N챕터마다 다음 월드 테마로 전환한다. 기본값은 global.tsv의 30. */
  chapterSpan: r.getInt(K.worldChapterSpan),
  /** 월드별 적 난이도 보정식. `{world}`, `{localChapter}`, `{chapterSpan}`을 사용한다. */
  brickHpWorldMultiplierExpr: r.getString(K.brickHpWorldMultiplierExpr),
  /** 월드별 골드 보정식. `{world}`, `{localChapter}`, `{chapterSpan}`을 사용한다. */
  brickGoldWorldMultiplierExpr: r.getString(K.brickGoldWorldMultiplierExpr),
} as const;

function worldExponent(worldNo: number): number {
  if (!Number.isFinite(worldNo)) return 0;
  return Math.max(0, Math.floor(worldNo) - 1);
}

function worldFormulaParams(
  worldNo: number,
  localChapter: number = 1,
  chapterSpan: number = WORLD.chapterSpan,
): Record<string, number> {
  const world = worldExponent(worldNo) + 1;
  const safeSpan = Math.max(2, Math.floor(Number.isFinite(chapterSpan) ? chapterSpan : WORLD.chapterSpan));
  const safeLocalChapter = Math.min(
    safeSpan,
    Math.max(1, Math.floor(Number.isFinite(localChapter) ? localChapter : 1)),
  );
  return { world, localChapter: safeLocalChapter, chapterSpan: safeSpan };
}

export function worldDifficultyMultiplier(
  worldNo: number,
  localChapter: number = 1,
  chapterSpan: number = WORLD.chapterSpan,
): number {
  const value = evaluateFormula(WORLD.brickHpWorldMultiplierExpr, worldFormulaParams(worldNo, localChapter, chapterSpan));
  return Number.isFinite(value) && value > 0 ? value : 1;
}

export function worldGoldMultiplier(
  worldNo: number,
  localChapter: number = 1,
  chapterSpan: number = WORLD.chapterSpan,
): number {
  const value = evaluateFormula(WORLD.brickGoldWorldMultiplierExpr, worldFormulaParams(worldNo, localChapter, chapterSpan));
  return Number.isFinite(value) && value > 0 ? value : 1;
}
